var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "48px", "flex-wrap": "nowrap" } },
        [
          _c(
            "v-layout",
            { staticClass: "unitAlertsHeader", attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("span", { staticClass: "unitAlertName" }, [
                  _vm._v("ALERTS FOR CLIENTS IN UNIT " + _vm._s(_vm.unit.name))
                ])
              ])
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { xs: "", icon: "", flat: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.close()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        { staticStyle: { height: "calc(90vh - 96px)" } },
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            staticStyle: { height: "100%" },
            attrs: {
              headers: _vm.headers,
              items: _vm.unitAlertCodes,
              "hide-actions": ""
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c("tr", { staticStyle: { height: "24px !important" } }, [
                      _c("td", [_vm._v(_vm._s(props.item.alertName))]),
                      _c("td", [_vm._v(_vm._s(props.item.roomName))]),
                      _c("td", [_vm._v(_vm._s(props.item.clientFirstName))]),
                      _c("td", [_vm._v(_vm._s(props.item.clientLastName))])
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("v-card-actions")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }